import { render, staticRenderFns } from "./ManageAdyenPlatformAccountHolder.vue?vue&type=template&id=e145bdd2"
import script from "./ManageAdyenPlatformAccountHolder.vue?vue&type=script&lang=js"
export * from "./ManageAdyenPlatformAccountHolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports